export function isValidUrl(value: string | null | undefined): value is string {
  if (!value) {
    return false
  }
  try {
    new URL(value)
    return true
  } catch {
    return false
  }
}

// Links opened from the mobile app must be https (iOS App Transport Security blocks http); empty means "no link"
export function isWebUrl(value: string): boolean {
  if (!value) {
    return true
  }
  try {
    return new URL(value).protocol === 'https:'
  } catch {
    return false
  }
}

// Same "something@something.tld" shape check as the API's assertEmail
export function isEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
}
